import React, {PureComponent} from 'react';
import {hashHistory} from 'react-router';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as _ from 'lodash';

import {NavigatorContainer} from "../Navigator";
import A from './FeatureCreatorNewActions';

const mapStateToProps = (state, props) => {
  const {featuresCreatorNew} = state;
  return {
    updateItemCount: _.size(featuresCreatorNew.pendingFeatures),
    catId: state.routing.locationBeforeTransitions.query.catId
  }
}

const mapDispatchToProps = dispatch => {
  return {
    cancelPendingChanges: (catId) => dispatch(A.cancelPendingChanges(catId)),
    savePendingChanges: (catId) => dispatch(A.savePendingChanges(catId))
  }
}

// <NavigatorContainer hideHomeButton="true"/>

class FeatureCreatorFooterNew extends PureComponent {
  render() {
    return (<div className='app-footer'>
      <div className="footer-nav-bar">
        <div className="lightbox-back-button" onClick={() => hashHistory.goBack()}>&#x21E0; Back</div>
      </div>
      
      <div className="lightbox-button-block">
        {this.props.updateItemCount ?
          <div className="lightbox-save-button"
               onClick={() => this.props.savePendingChanges(this.props.catId)}>Save
            <span className='updateCount'
                  title="Unsaved item count">{this.props.updateItemCount}</span>
          </div>
          : null}
        {this.props.updateItemCount ?
          <div className="lightbox-cancel-button"
               onClick={() => this.props.cancelPendingChanges(this.props.catId)}>Cancel
          </div>
          : null}
      </div>
    </div>)
  }
}

FeatureCreatorFooterNew.propTypes = {
  updateItemCount: PropTypes.number.isRequired,
  savePendingChanges: PropTypes.func.isRequired,
  cancelPendingChanges: PropTypes.func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(FeatureCreatorFooterNew);

